export const DISABLED_DAYS = {
  daysOfWeek: [0, 6],
};
